module.exports = new __parcel__URL__("FLDAS_Dataset_Cover.d973ed7c.jpg").toString();